import { render, staticRenderFns } from "./DynamicDomainNameForm.vue?vue&type=template&id=1568bcfc&"
import script from "./DynamicDomainNameForm.vue?vue&type=script&lang=js&"
export * from "./DynamicDomainNameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports